import 'jquery';
import 'bootstrap';
import './js/index';
import './scss/main.scss';